import { Xmark } from '@gravity-ui/icons';
import { Button, Modal } from '@gravity-ui/uikit';

import { CANCEL, CONFIRMATION_DELETE, DELETE, DELETE_QUESTION } from 'features/blank/constants';

import styles from './styles.module.scss';

interface DeleteModalProps {
	open: boolean;
	setOpen: (open: boolean) => void;
	onConfirm: () => void;
}

export const DeleteBlankModal = ({ open, setOpen, onConfirm }: DeleteModalProps) => {
	return (
		<Modal open={open} className={styles.modal}>
			<div className={styles.modal__title}>
				<h3>{CONFIRMATION_DELETE}</h3>
				<Xmark onClick={() => setOpen(false)} cursor="pointer" />
			</div>
			<div className={styles.modal__content}>{DELETE_QUESTION}</div>
			<div className={styles.modal__btns}>
				<Button onClick={() => setOpen(false)} size="xl" view="flat">
					{CANCEL}
				</Button>
				<Button
					onClick={() => {
						onConfirm();
						setOpen(false);
					}}
					size="xl"
					view="outlined-danger"
				>
					{DELETE}
				</Button>
			</div>
		</Modal>
	);
};
